import moment from 'moment';
import { assoc, propOr, startsWith } from 'ramda';

import { dateToStr } from './commonMapper';
import { EVENT_RESULT_TYPES } from 'constants/events';
import { DATE_FORMATS } from 'constants/dateFormats';
import { toBase64 } from 'helpers/base64Helper';
import Parser from 'helpers/parser';
import evolve from './evolve';

const { FILE, FORM } = EVENT_RESULT_TYPES;

const EventMapper = {
    text: (field, event) => {
        let {details} = event;
        let result = {};

        if (details) {
            result.name = details.people ? details.people[0].text : '';
            result.date = moment(details.eventDate || null, DATE_FORMATS.parse).format(DATE_FORMATS.format);
            result.character = details.name;
        } else {
            result.name = Parser.name.get(event.text) || (/<.*?(?=>\s\()/.exec(event.text) || [''])[0].slice(1);
            result.date = Parser.date.get(event.text).replace(/\//g, '.');
            result.character = (/\s([^<]+)(?=\s<)/.exec(event.text) || [''])[0].trim();
            result.character = startsWith('*', event.text) ? `*${result.character}` : result.character;
            result.info = event.text.replace(/([*\d\D]+)> \(/, '').replace('> (', '').replace('))', ')');
        }

        result.title = field;
        return result;
    },
    bodyResult: (field) => ({
        ...field,
        body: field.resultType === EVENT_RESULT_TYPES.FILE ? field.body : toBase64(field.body),
    }),
    shortResult: (block) => {
        if (!block) {
            return null;
        }

        if (block.percent) {
            block.percent = +block.percent;
        }

        if (block.resultCode) {
            block.resultCode = +block.resultCode;
        } else {
            delete block.resultCode;
        }

        return assoc('tookPlace', !(block.tookPlace - 1), block);
    },
    shortResultDecode: (block) => {
        if (!block) {
            return null;
        }

        return assoc('tookPlace', +(!block.tookPlace) + 1, block);
    },
    documentResult: ({ id, script, xmlbody, body, dockey, file, resultType, type, eventWithScript }) => {
        if (dockey) {
            return {
                docDB: {
                    result: {
                        type,
                        dockey: Number(dockey),
                    }
                }
            };
        }

        if (resultType === FORM) {
            return eventWithScript ? ({
                script: {
                    result: {
                        script: toBase64(JSON.stringify(script)),
                        fileType: 'script',
                        id,
                        type,
                    }
                },
            }) : ({
                xmlbody: {
                    result: {
                        type,
                        xmlbody: evolve({
                            'MainData': {
                                INTDATE: dateToStr
                            },
                            'PhoneIntervMain': {
                                INTDATE: dateToStr
                            },
                            'IntervMain': {
                                IntDate: dateToStr
                            },
                            'MRKTCALL': {
                                NEXTDATE: dateToStr,
                                DATE: dateToStr,
                            },
                        })(xmlbody),
                    },
                },
            });
        }

        return {
            body: {
                result: {
                    type,
                    body: resultType === FILE ? file.body : toBase64(body),
                    fileType: propOr('txt', 'fileType', file),
                },
            },
        };
    },
};

export default EventMapper;
